import axios from 'axios'

export function PolicyInfor(params) {
    return axios.post(`/IAD_StrategyData/list?_t=${new Date().getTime()}`, params).then(res => {
        return Promise.resolve(res.data)
      }).catch(err => {
        return Promise.reject(err)
      })
}


export function materialInfor(params) {
    return axios.post(`/IAD_MaterialData/list?_t=${new Date().getTime()}`, params).then(res => {
        return Promise.resolve(res.data)
      }).catch(err => {
        return Promise.reject(err)
      })
}

export function mediaInfor(params) {
    return axios.post(`/IAD_MediaData/list?_t=${new Date().getTime()}`, params).then(res => {
        return Promise.resolve(res.data)
      }).catch(err => {
        return Promise.reject(err)
      })
}



// WEBPACK FOOTER //
// ./src/api/policyservers.js